$(function() {
	$('.nav__link:not(.nav__link_social)').click(function (e) {
		e.preventDefault();
		var id = $(this).attr('href'),
			top = $(id).offset().top;
		headerHeight = $('.header').outerHeight();
		
		$('html').animate({
			scrollTop: top - (headerHeight * 1.5)
		}, 1000);
		$('.js-burger').removeClass('burger_active');
		$('.header').removeClass('header_active');
		$('.header__nav').removeClass('header__nav_active');
		$('body').removeClass('o-hidden');
	});
})